/*
 * @Author: lyl name
 * @Date:20210621
 * @LastEditTime: 2020-04-13 11:24:39
 * @Description: 用于验证某个文件是否存在
 */
import axios from 'axios';
import { toast } from './common';
import { UserModule } from '@/store/modules/user';
const service = axios.create({
  // baseURL: process.env.VUE_APP_ANDROID_BASE_API,

  timeout: 30000,
});
service.interceptors.request.use(
  config => {
    if (UserModule.token) {
      config.headers['x-token'] = UserModule.token;
    }
    if (UserModule.activeBrand) {
      config.headers['x-appId'] = UserModule.activeBrand;
    }
    return config;
  },
  error => {
    Promise.reject(error);
  }
);
service.interceptors.response.use(
  response => {
    const { headers, status, data } = response;

    if (status >= 200 && status < 400) {
      return data;
    }
    if (status === 401) {
      toast(data.msg, 'error');
      return Promise.reject(response);
    }
  },
  error => {
    return Promise.reject(error);
  }
);
export default service;
